import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux';
import {
  /*EditOutlined,
  SettingOutlined,
  ShopOutlined,
  QuestionCircleOutlined,*/
  LogoutOutlined,
  UserOutlined
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import {signOut} from "../../redux/actions/Auth";


const menuItem = [
	/*{
		title: "Edit Profile",
		icon: EditOutlined ,
		path: "/"
    },

    {
		title: "Account Setting",
		icon: SettingOutlined,
		path: "/"
    },
    {
		title: "Billing",
		icon: ShopOutlined ,
		path: "/"
	},
    {
		title: "Help Center",
		icon: QuestionCircleOutlined,
		path: "/"
	}*/
]

export const NavProfile = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth)
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} icon={<UserOutlined />} />
          <div className="pl-3">
            <h4 className="mb-0">{auth.name}</h4>
            <span className="text-muted">{auth.email}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={() => dispatch(signOut())}>
            <span>
              <LogoutOutlined className="mr-3"/>
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <Avatar icon={<UserOutlined />} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, {})(NavProfile)
